<template>
  <div
    class="form-group"
    :class="{
      'row ': formGroupRow,
      'label-requires': required || rules.required,
      [`${formGroupClass}`]: formGroupClass,
    }"
  >
    <label
      v-if="type !== 'divider'"
      :class="{ [`${labelClass}`]: labelClass }"
      style="margin-bottom: 6px"
      class="d-block form-label"
      >{{ $t(label) + labelAfterFix || "" }}</label
    >
    <validation-provider #default="{ errors }" :rules="rules" :name="$t(label)">
      <WidgetDateTime
        :clearable="!noClearable"
        :timePicker="timePicker"
        :max-date="maxDate"
        :disabled="disabled"
        :isRange="isRange"
        v-model="currentValue"
        :placeholder="$t(placeholder) || $t(label)"
        v-if="type === 'date'"
      />
      <WidgetSelect
        :disabledItemAfterFix="disabledItemAfterFix"
        :disabledItem="disabledItem"
        :defaultValue="defaultValue"
        :customOptions="customOptions"
        :errors="errors"
        :placeholder="placeholder || label"
        :dataSource="dataSource"
        :multiple="multiple"
        :noClearable="noClearable"
        :dataSourceParams="dataSourceParams"
        :label="labelOption"
        :disabled="disabled"
        :customReduce="customReduce"
        v-if="type === 'select'"
        v-model="currentValue"
      />
      <WidgetDivider :variant="variant" v-if="type === 'divider'" :label="label" />
      <WidgetString
        v-model="currentValue"
        :disabled="disabled"
        :rows="rows"
        :variant="variant"
        :errors="errors"
        :placeholder="placeholder || label"
        v-if="type === 'string'"
      />
      <WidgetCleave
        :cleaveOptions="cleaveOptions"
        :defaultValue="defaultValue"
        :errors="errors"
        :type="cleaveType"
        :disabled="disabled"
        v-model="currentValue"
        :placeholder="placeholder || label"
        v-if="type === 'cleave'"
      />
      <div
        v-if="currentValue && showVnPriceText"
        class="text-right font-weight-bold font-italic text-primary"
        style="font-size: 10px; margin-top: 6px"
      >
        {{ numberToVnText(currentValue) }}
      </div>
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </div>
</template>
<script>
import { ValidationProvider, extend } from "vee-validate";
import WidgetSelect from "../Select/WidgetSelect.vue";
import WidgetDateTime from "../DateTime/WidgetDatetime.vue";
import WidgetDivider from "../Separate/WidgetDivider.vue";
import WidgetCleave from "../Cleave/WidgetCleave.vue";
import WidgetString from "../String/WidgetString.vue";
export default {
  name: "FormItem",
  props: {
    disabledItemAfterFix: String,
    disabledItem: Function,
    value: [String, Number, Object, Array, Boolean, Date],
    customValidate: {
      type: Object,
      default() {
        return {};
      },
    },
    cleaveOptions: {
      type: Object,
      default() {
        return {};
      },
    },
    formData: {
      type: Object,
      default() {
        return {};
      },
    },
    hide: Boolean,
    labelAfterFix: {
      type: String,
      default: "",
    },
    showVnPriceText: Boolean,
    rangeData: Array,
    rows: Number,
    maxDate: [Date, String],
    data: null,
    timePicker: Boolean,
    noClearable: Boolean,
    customOptions: Function,
    formGroupRow: Boolean,
    labelClass: String,
    isRange: Boolean,
    cleaveType: String,
    defaultValue: [Number, String, Function, Array, Object],
    formGroupClass: String,
    disabled: [Boolean, String, Number],
    variant: String,
    rules: {
      type: Object,
      default: {},
    },
    type: {
      type: String,
      required: true,
    },
    dataSource: {
      type: [Function, Array],
      nullable: true,
    },
    dataSourceParams: {
      type: [Object, Array, String],
      nullable: true,
    },
    labelCols: Number,
    labelOption: String,
    pattern: {
      type: Object,
      default: () => {
        return {};
      },
    },
    label: String,
    required: Boolean,
    name: String,
    customReduce: {
      type: String,
    },
    placeholder: {
      type: String,
    },

    multiple: {
      type: Boolean,
    },
    labelOption: {
      type: String,
    },

    singleDatePicker: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      currentValue: "",
    };
  },
  watch: {
    currentValue(value) {
      this.updateData(value);
    },
    value: {
      handler: function (v) {
        console.log(v, "1811");
        this.currentValue = v;
      },
      deep: true,
    },
    /* data(){
      
    } */
  },
  methods: {
    lowerCaseFirstLetter(text) {
      let temp = "";
      if (text) {
        temp = text[0].toLowerCase() + text.substring(1, text.length);
      }
      return temp;
    },
    updateData(v) {
      console.log(v, "1899");
      this.$emit("input", v);
    },
    renderVModel(defaultVModel) {
      if (!defaultVModel) {
        return;
      }
    },
    handleChange(v) {},
  },
  mounted() {
    /* if(this.formData ){
      console.log(this.rangeData[0],"1766")
      if(this.rangeData && this.formData[this.rangeData[0]] && this.formData[this.rangeData[1]]){

        this.currentValue = {
          startDate:this.formData[this.rangeData[0]],
          endDate:this.formData[this.rangeData[1]],
    
        }
      }
    
    } */
    if (this.value) this.currentValue = this.value;
    if (this.pattern.value) {
      extend("pattern", {
        validate: (value) => this.pattern.value.test(value),
        message: this.pattern?.message,
      });
    }

    if (this.customValidate?.isValid) {
      extend("customValidate", {
        validate: (value) => !this.customValidate.isValid(value),
        message: this.customValidate?.message,
      });
    }
    if (this.rules?.maxValue) {
      extend("maxValue", {
        validate: (value) => value <= this.rules.maxValue,
        message: this.$t("ar_client_value_greater_than", {
          num: this.lowerCaseFirstLetter(this.numberToVnText(this.rules.maxValue)),
        }),
      });
    }
  },
  components: {
    WidgetDivider,
    WidgetCleave,
    ValidationProvider,
    WidgetDateTime,
    WidgetSelect,
    WidgetString,
  },
};
</script>
